import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
// import PhoneInput from "react-phone-number-input";
import { formatPhoneNumberIntl } from "react-phone-number-input";
// import "react-phone-number-input/style.css";
import "react-phone-input-2/lib/style.css";
import Continue from "../../components/Buttons/Button";
import Button from "../../components/Buttons/Button";
import Header from "../../components/Header";
import useWindowDimensions from "../../helpers/Hooks/useWindowDimensions";
import { routes } from "../../helpers/Routes";
import { useNavigate } from "react-router-dom";
import Version from "../../components/Version";
import { toast } from "react-hot-toast";

// import "react-phone-input-2/lib/plain.css";

const ApplyForCredit = () => {
  const navigate = useNavigate();
  const emailRef = useRef();
  const ssnTwoRef = useRef();
  const ssnThreeRef = useRef();
  const { height, width } = useWindowDimensions();
  // let isDisabled = false;
  const [flag, setFlag] = useState("us");
  const [isDisabled, setIsDisabled] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [ssnOne, setSsnOne] = useState("");
  const [ssnTwo, setSsnTwo] = useState("");
  const [ssnThree, setSsnThree] = useState("");
  const ssn = ssnOne + ssnTwo + ssnThree;
  const [mobile, setMobile] = useState("");
  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const [ssnError, setSsnError] = useState(false);

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  // const emailRegex = new RegExp(
  //   /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/,
  //   "gm"
  // );
  const isValidEmail = emailRegex.test(email);
  // console.log(isValidEmail);
  const [emailError, setEmailError] = useState(isValidEmail);

  const limit_ssn1 = 3;
  const limit_ssn2 = 2;
  const limit_ssn3 = 4;

  const CheckSSN = (value, name, e) => {
    var regex = /^[0-9]+$/;
    if (name === "SSN_ONE") {
      let finalValue = value.slice(0, limit_ssn1);
      !isNaN(e.nativeEvent?.data) && setSsnOne(finalValue);
      // if (ssnOne.length === 3 && regex.test(ssnOne)) {
      // } else {
      //   toast.error("Invalid SSN");
      // }
    }
    if (name === "SSN_TWO") {
      let finalValue = value.slice(0, limit_ssn2);
      !isNaN(e.nativeEvent?.data) && setSsnTwo(finalValue);
    }
    if (name === "SSN_THREE") {
      let finalValue = value.slice(0, limit_ssn3);
      !isNaN(e.nativeEvent?.data) && setSsnThree(finalValue);
    }
  };
  // console.log(ssn);

  // Checks the SSN inputs has all values according to the limit and focus moves to next corresponding input
  // useEffect(() => {
  //   var regex = /^\d{3}-?\d{2}-?\d{4}$/;
  //   var regex = /^[0-9]+$/;

  // if(ssnOne )

  // if (ssnOne.length === 3) {
  // if (regex.test(ssnOne)) {
  // if (ssnOne !== "" && ssnOne.length === 3 && regex.test(ssnOne)) {
  //   ssnTwoRef?.current?.focus();
  //   if (ssnTwo !== "" && ssnTwo.length === 2 && regex.test(ssn)) {
  //     ssnThreeRef?.current?.focus();
  //     if (ssnThree !== "" && ssnThree.length === 4 && regex.test(ssn)) {
  //       if (email === "") {
  //         emailRef?.current?.focus();
  //       }
  //       // toast.success("Correct SSN");
  //       // navigate(routes.connectBank);
  //       setIsDisabled(true);
  //     } else {
  //       // toast.error("Invalid SSN");
  //       setSsnError(true);
  //       setIsDisabled(false);
  //     }
  //   } else {
  //     // toast.error("Invalid SSN");
  //     setSsnError(true);
  //     setIsDisabled(false);
  //   }
  // } else {
  //   // toast.error("Invalid SSN");
  //   setSsnError(true);
  //   setIsDisabled(false);
  // }
  // }, [ssnError, ssnOne, ssnTwo, ssnThree]);

  // checks ssn has 9 characters
  useEffect(() => {
    var regex = /^[0-9]+$/;
    // if (ssnOne !== "" && ssnOne.length === 3 && regex.test(ssnOne)) {
    //   // toast.success("Correct SSN");
    //   ssnTwoRef?.current?.focus();
    // } else {
    //   // toast.error("Invalid SSN");
    // }

    if (ssn.length === 9) {
      setSsnError(false);
    }
    // if (ssnOne !== "" && ssnOne.length !== 3) {
    //   setSsnError(true);
    // }
  }, [ssn, ssnOne, ssnTwo, ssnThree]);

  useEffect(() => {
    if (mobile.length === 0) {
      setFlag("-1");
    }
  }, [mobile, flag]);
  // console.log(mobile);

  // useEffect(() => {
  //   if (email !== "") {
  //     if (isValidEmail === true) {
  //       // setEmailError(false);
  //       setIsDisabled(true);
  //     }
  //   } else {
  //     // toast.error("Invalid Email");
  //     // setEmailError(true);
  //     setIsDisabled(false);
  //   }
  // }, [email, isValidEmail]);
  // console.log(isValidEmail);
  // console.log("isDisabled", isDisabled);

  // On tap the Apply for credit --> Populate the data in all fields
  const onPageTitleClick = (e) => {
    setFirstName("Peter");
    setLastName("Parker");
    setSsnOne("123");
    setSsnTwo("45");
    setSsnThree("2314");
    setEmail("peter.parker@gmail.com");
    setMobile("11234567890");
    setIsTermsChecked(true);
  };

  //! Continue button becomes blue/use when all field are entered and become true
  useEffect(() => {
    if (
      firstName !== "" &&
      lastName !== "" &&
      ssnOne !== "" &&
      ssnTwo !== "" &&
      ssnThree !== "" &&
      email !== "" &&
      mobile !== "" &&
      isTermsChecked !== false
    ) {
      setIsDisabled(true);
    }
  }, [
    firstName,
    lastName,
    ssnOne,
    ssnTwo,
    ssnThree,
    email,
    mobile,
    isTermsChecked,
  ]);

  const onContinueClick_Apply = (e) => {
    e.preventDefault();

    if (
      firstName !== "" &&
      lastName !== "" &&
      ssnOne !== "" &&
      ssnTwo !== "" &&
      ssnThree !== "" &&
      email !== "" &&
      mobile !== "" &&
      isTermsChecked !== false
    ) {
      // setIsDisabled(true)
      navigate(routes.connectBank);
    }

    //! var regex = /^[0-9]+$/;
    // if (
    //   firstName !== "" &&
    //   lastName !== "" &&
    //   ssnOne !== "" &&
    //   ssnTwo !== "" &&
    //   ssnThree !== "" &&
    //   email !== "" &&
    //   mobile !== "" &&
    //   isTermsChecked !== false
    // ) {
    //   if (isTermsChecked !== false && isValidEmail !== false) {
    //     if (ssnOne !== "" && ssnOne.length === 3 && regex.test(ssn)) {
    //       // alert("SSN 2 focus");
    //       ssnTwoRef?.current?.focus();
    //       if (ssnTwo !== "" && ssnTwo.length === 2 && regex.test(ssn)) {
    //         ssnThreeRef?.current?.focus();
    //         if (
    //           ssnThree !== "" &&
    //           ssnThree.length === 4 &&
    //           regex.test(ssnThree)
    //         ) {
    //           // if (email === "") {
    //           //   emailRef?.current?.focus();
    //           //   // setEmailError(true);
    //           // }
    //           // toast.success("Correct SSN");
    //           // toast.success("Continue");
    //           navigate(routes.connectBank);
    //           // console.log(ssn.length);
    //           setIsDisabled(true);
    //         } else {
    //           // toast.error("Invalid SSN");
    //           // console.log(ssn);
    //           // setSsnError(true);
    //           setIsDisabled(false);
    //         }
    //       } else {
    //         // toast.error("Invalid SSN");
    //         // console.log(ssn);
    //         // setSsnError(true);
    //         setIsDisabled(false);
    //       }
    //     } else {
    //       setIsDisabled(false);
    //     }
    //   } else {
    //     setIsDisabled(false);
    //   }
    // } else {
    //   setIsDisabled(false);
    //! }
  };

  //! Checks All fields are filled, termsCondition is true & Checks the SSN is valid
  //! useEffect(() => {
  //   if (
  //     firstName !== "" &&
  //     lastName !== "" &&
  //     ssnOne !== "" &&
  //     ssnTwo !== "" &&
  //     ssnThree !== "" &&
  //     email !== "" &&
  //     mobile !== "" &&
  //     isTermsChecked !== false
  //   ) {
  //     if (isValidEmail !== false) {
  //       setIsDisabled(true);
  //     } else {
  //       setIsDisabled(false);
  //     }
  //   } else {
  //     setIsDisabled(false);
  //   }
  // }, [
  //   firstName,
  //   lastName,
  //   isDisabled,
  //   ssnOne,
  //   ssnTwo,
  //   ssnThree,
  //   email,
  //   mobile,
  //   isTermsChecked,
  //   isValidEmail,
  //! ]);

  // move the ssn input automatically
  useEffect(() => {
    var regex = /^[0-9]+$/;
    if (ssnOne !== "" && ssnOne.length === 3 && regex.test(ssn)) {
      ssnTwoRef?.current?.focus();
      if (ssnTwo !== "" && ssnTwo.length === 2 && regex.test(ssn)) {
        ssnThreeRef?.current?.focus();
        // if (ssnThree !== "" && ssnThree.length === 4 && regex.test(ssn)) {
        // emailRef?.current?.focus();
        // setEmailError(true);
        // setIsDisabled(true);
        // } else {
        //   setIsDisabled(false);
        //   // setSsnError(true);
        // }
      } else {
        setIsDisabled(false);
        // setSsnError(true);
      }
    } else {
      setIsDisabled(false);
      // setSsnError(true);
    }
  }, [ssnOne, ssnTwo]);

  return (
    <>
      <Header />
      <main
        className="px-6 h-full flex flex-col"
        style={{ height: `${height - 76}px` }}
      >
        <main className="flex-grow">
          <section className="flex items-center justify-center">
            <div className="mb-4 text-blackText text-xl font-bold cursor-pointer">
              Apply for credit
            </div>
          </section>
          {/* All Inputs */}
          <form>
            <div className="">
              <label className="labelTag">First Name</label>
              <input
                type={"text"}
                placeholder={"Enter first name"}
                // pattern={/^[a-zA-Z\s]*$/}
                className="inputTag"
                value={firstName}
                onClick={onPageTitleClick}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="mt-3">
              <label className="labelTag">Last Name</label>
              <input
                type={"text"}
                placeholder={"Enter last name"}
                className="inputTag"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="mt-3">
              <label className="labelTag">Social Security Number</label>
              <div className="flex items-center justify-between space-x-4">
                <input
                  type={"tel"}
                  placeholder={"XXX"}
                  // maxLength={3}
                  // pattern={"^(0|[1-9][0-9]*)$"}
                  // pattern="^[0-9]*$"
                  // pattern="^[0-9\b]+$"
                  className="inputTag"
                  value={ssnOne}
                  onChange={(e) => CheckSSN(e.target.value, "SSN_ONE", e)}
                />
                {/* <span className="flex items-center justify-center">-</span> */}
                <input
                  type={"tel"}
                  ref={ssnTwoRef}
                  placeholder={"XX"}
                  // pattern={"/^[0-9]+$/"}
                  // maxLength={2}
                  value={ssnTwo}
                  className="inputTag"
                  onChange={(e) => CheckSSN(e.target.value, "SSN_TWO", e)}
                />
                {/* <span className="flex items-center justify-center">-</span> */}
                <input
                  type={"tel"}
                  ref={ssnThreeRef}
                  placeholder={"XXXX"}
                  // pattern={"/^[0-9]+$/"}
                  // maxLength={4}
                  value={ssnThree}
                  className="inputTag"
                  onChange={(e) => CheckSSN(e.target.value, "SSN_THREE", e)}
                />
              </div>
              {/* {ssnError ? (
                <p className="labelTag mt-2 text-xs text-red-500">
                  Invalid SSN
                </p>
              ) : null} */}
              {/* <p>{ssn.length !== 9 ? ssnError : null}</p> */}
            </div>
            <div className="mt-3">
              <label className="labelTag">Email Address</label>
              <input
                type={"email"}
                ref={emailRef}
                placeholder={"Enter email address"}
                className="inputTag"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {/* {emailError ? (
                <p className="labelTag mt-2 text-xs text-red-500">
                  Invalid Email Address
                </p>
              ) : null} */}
            </div>
            <div className="mt-3">
              {/* {} */}
              <label className="labelTag">Phone Number</label>
              {/* <PhoneInput
            defaultCountry="US"
            className="phoneInput"
            // className="outline-none"
            value={mobile}
            onChange={(value) => setMobile(formatPhoneNumberIntl(value))}
          /> */}
              <PhoneInput
                specialLabel=""
                country="us"
                //   country={
                //     (e) => {
                //     console.log(e);
                //   }
                // }
                // country={(e) => {
                //   console.log(e.indexOf);
                // }}
                inputStyle={{
                  width: "100%",
                  padding: "26px 20px 26px 60px",
                  fontFamily: "Montserrat, sans-serif",
                  // border: "none"
                  borderColor: "#EFF3F4",
                }}
                buttonStyle={{ padding: "5px", borderColor: "#EFF3F4" }}
                placeholder={"Enter mobile number"}
                // showDropdown={true}
                value={mobile}
                onChange={(value, e, data) => {
                  // formatPhoneNumberIntl(value);
                  // console.log(value.length);
                  // console.log(data);
                  // console.log(e);

                  setMobile(value);
                }}
              />
            </div>
          </form>
        </main>
        <section>
          <section className="mt-4 mb-4 flex items-center justify-center">
            <input
              id="terms_and_condition"
              type={"checkbox"}
              className="h-4 w-4 mr-2"
              defaultChecked={isTermsChecked}
              checked={isTermsChecked}
              value={isTermsChecked}
              onChange={() => {
                setIsTermsChecked(!isTermsChecked);
              }}
            />
            <label
              htmlFor="terms_and_condition"
              className="text-blackText text-xs font-medium"
            >
              I agree to Generic Lender's{" "}
              <span className="text-primary underline">terms & conditions</span>
            </label>
          </section>
          <Button
            name={"Continue"}
            isDisabled={isDisabled}
            onContinueClick_Apply={onContinueClick_Apply}
          />
        </section>
        {/* <Version /> */}
      </main>
    </>
  );
};

export default ApplyForCredit;
